import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import appconstant from "../../../themes/appconstant";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import moment from "moment";
import { wellnessActivityLoad } from "../../../redux/slices/dash.slice";
import { Option } from "antd/lib/mentions";

const ActivityChart = ({ myid, department }) => {
  const dispatch = useDispatch();
  const [selectedMonth, setSelectedMonth] = useState(moment().month());

  useEffect(() => {
    const monthIndex = selectedMonth;
    const data = {
      organisation: myid,
      month: monthIndex,
      department,
    };
    dispatch(wellnessActivityLoad(data));
  }, [selectedMonth, department]);

  const mydata =
    useSelector((state) => state.dashboardReducer.wellnessActivityData) || {};
  const allaffirmation = mydata[0]?.allAffirmation || {};
  const allJournal = mydata[0]?.allJournal || {};

  const option = {
    legend: {
      data: ["Journaling", "Affirmation"],
      textStyle: {
        color: "#2F2F2FCC",
        fontSize: 12,
        fontWeight: 400,
      },
      right: 20,
    },
    title: {
      subtext: "Number of Participants",
      left: 30,
    },
    xAxis: {
      type: "category",
      data: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
      ],
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      splitLine: {
        show: false,
      },
    },
    color: ["#D4648A", "#7C63A4", "#D6A2BE"],
    series: [
      {
        name: "Journaling",
        data: Object.values(allJournal),
        type: "bar",
        barWidth: 7,
        barGap: 0,
        barCategoryGap: 0,
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
        },
      },
      {
        name: "Affirmation",
        data: Object.values(allaffirmation),
        type: "bar",
        barWidth: 7,
        barGap: 0,
        barCategoryGap: 0,
        itemStyle: {
          borderRadius: [10, 10, 0, 0],
        },
      },

      // {
      //   name: 'Meditation',
      //   data: [120, 20, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 191, 130, 120, 200, 150, 80, 70, 110, 130, 10, 23, 34],
      //   type: 'bar',
      //   barWidth: 7,
      //   barGap: 0,
      //   barCategoryGap: 0,
      //   itemStyle: {
      //     borderRadius: [10, 10, 0, 0]
      //   }
      // }
    ],
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };

  return (
    <div className="mb-6">
      <div className=" shadow-metafit-shadow bg-white border rounded-[10px] ">
        <div className="p-4  border-b mb-6 flex justify-between items-center">
          <div className="text-base font-semibold text-dark ">
            {appconstant.WellnessActivitiesParticipation}
          </div>
          <div className="flex gap-1 items-center months-selector">
            <Select
              defaultValue={moment().format("MMMM")}
              onChange={handleMonthChange}
            >
              {moment.months().map((month, index) => (
                <Option key={index} value={index}>
                  {month}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <ReactEcharts option={option} />
      </div>
    </div>
  );
};

export default ActivityChart;
